module.exports = __webpack_public_path__ + "img/c4a2762a51061f7665b6eba43859560.44e09c8a.jpg";